import type { SrpTopEmployersStripItem } from '../../types/srp-top-employers-strip';
import type { FacetsData } from '../facets/facets-shared';

function displayNameFromHit(hit: Record<string, unknown>): string {
  const company = hit.company;
  if (Array.isArray(company) && company.length > 0) {
    const first = company[0];
    if (typeof first === 'string' && first.trim()) return first.trim();
  }
  if (typeof company === 'string' && company.trim()) return company.trim();
  const cid = String(hit.companyId ?? '').trim();
  return cid;
}

/**
 * When the companies-index query returns nothing, derive top employers for the SRP strip from the
 * same job search response (companyId facet + hit labels) so SSR still includes real links/names.
 */
export function buildTopEmployersStripFallbackFromSearch(
  facetsData: FacetsData | undefined,
  hits: Array<Record<string, unknown>> | undefined,
  limit: number
): SrpTopEmployersStripItem[] {
  if (!Number.isFinite(limit) || limit <= 0) return [];
  const companyFacets = facetsData?.companyId;
  if (!Array.isArray(companyFacets) || companyFacets.length === 0) return [];

  const nameById = new Map<string, string>();
  for (const hit of hits ?? []) {
    const id = String(hit?.companyId ?? '').trim();
    if (!id || nameById.has(id)) continue;
    const name = displayNameFromHit(hit);
    nameById.set(id, name.trim() ? name : id);
  }

  const out: SrpTopEmployersStripItem[] = [];
  for (const item of companyFacets) {
    const value = typeof item.value === 'string' ? item.value.trim() : '';
    if (!value) continue;
    const count = typeof item.count === 'number' ? item.count : Number(item.count);
    if (!Number.isFinite(count) || count <= 0) continue;
    out.push({
      companyId: value,
      name: nameById.get(value) ?? value,
      logoUrl: null,
    });
    if (out.length >= limit) break;
  }
  return out;
}
